import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { environment } from '../../environments/environment';
import { AmbassadorProgramCompanyDTO } from '../models/ambassador-program-company-dto';
import { Select2Data } from 'ng-select2-component';

@Injectable({
  providedIn: 'root'
})

export class AmbassadorProgramCompanyService {

  private pathAPI = environment.urlAPI;
  private controller = "AmbassadorProgramCompany/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<AmbassadorProgramCompanyDTO> {
    return this.http.get<AmbassadorProgramCompanyDTO>(this.pathAPI + this.controller + id);
  }

  public getAllForSelect(idProgram: string): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetAllForSelect/' + idProgram);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }
    
  public getDataTable(data: any, idProgram: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idProgram, data);
  }

}
